import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import {ITafBookElemGraphS1} from './taf-book-graph-s1';

import { HttpHelper } from '../../../shared/http-helper';

import * as _ from 'lodash';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class TAFBookGraphS1Service {

    //private _tafBookGraphS1Url = ` http://localhost:55706/api/systemmanagement/TAFBookGraphS1`;
    private _tafBookGraphS1Url = `api/systemmanagement/TAFBookGraphS1`;
    
    constructor(private httpHelper: HttpHelper) { }

    getTAFGraphS1BookSplit(){
    return this.httpHelper.get(`${this._tafBookGraphS1Url}`);
        //return Observable.forkJoin(
          //  this.httpHelper.get(`${this._tafBookGraphS1Url}`));
            //.map((response: Response) => _.map(JSON.parse(JSON.stringify(response.json())),'locid')),
            //.do(httpHelper => console.log("trying to pull locid only in Service: " + data)),
           // this.httpHelper.get(`${this._tafBookGraphS1Url}`)
            //.map((response: Response) => _.map(JSON.parse(JSON.stringify(response.json())),'rateFyLfc')));
            //.do(httpHelper => console.log("trying to pull rates only in Service: " + data)));
    }
   
    private handleError(error: Response) {
         // in a real world app, we may send the server to some remote logging infrastructure
         // instead of just logging it to the console
         console.error(error);
         return Observable.throw(error.json().error || 'Server error');
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book-graph-s1/taf-book-graph-s1.service.ts
 **/